import BackNextNav from '@/components/common/BackNextNav';
import { FlexRow } from '@/components/common/Flex';
import {
    BigHeader,
    Paragraph,
    Subheader,
} from '@/components/common/Typography';
import PrivacyAndSharingSection from '@/components/partnershipInvites/PrivacyAndSharingSection';
import { useUserData } from '@/services/user';
import { Divider, FlexProps } from '@chakra-ui/react';
import { getPartnerName } from '@common/react/user';
import React from 'react';

interface AcceptInviteSummaryViewProps extends FlexProps {
    onNext: () => void;
    onBack: () => void;
}

export default function AcceptInviteSummaryView({
    onNext,
    onBack,
}: AcceptInviteSummaryViewProps) {
    const { partnerInfo } = useUserData();
    return (
        <>
            <BigHeader mb={5}>
                Get ready to use Plenty with{' '}
                {getPartnerName(partnerInfo, 'your partner')}
            </BigHeader>
            <Paragraph color="textMuted" mb={12}>
                Review your information. Click any item to make changes.
            </Paragraph>

            <PrivacyAndSharingSection />

            <Divider my={10} />
            <Subheader mb={7}>Your partner</Subheader>
            {[
                {
                    title: 'Email',
                    value: partnerInfo?.email,
                },
                {
                    title: 'Preferred Name',
                    value: partnerInfo?.preferredName,
                },
            ].map((r) => (
                <FlexRow
                    key={r.title}
                    alignItems="center"
                    mb={2}
                    cursor="pointer"
                    onClick={onBack}
                >
                    <Paragraph color="textMuted" flexGrow={1}>
                        {r.title}
                    </Paragraph>
                    <Paragraph>{r.value}</Paragraph>
                </FlexRow>
            ))}

            <BackNextNav
                mt={15}
                nextButtonText="Looks good"
                onBack={onBack}
                onNext={onNext}
                onClickEventParams={{
                    location: 'Accept Invite Summary View',
                }}
            />
        </>
    );
}
